function countUp(counter, start, end, duration) {
	const startTime = performance.now();
	const change = end - start;
	const metricElement = counter.querySelector('.metric');

	function update(value) {
		metricElement.textContent = value.toFixed(0);
	}

	function startAnimation() {
		requestAnimationFrame(function animation(currentTime) {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / (duration * 1000), 1);
			const currentValue = start + change * progress;

			update(currentValue);

			if (progress < 1) {
				requestAnimationFrame(animation);
			} else {
				update(end);
			}
		});
	}

	startAnimation();

	return {
		counter,
		start,
		end,
		duration,
		startAnimation,
	};
}

function initCountUp() {
	const counters = document.querySelectorAll('.wp-block-zp4-metric .counter');

	function onIntersection(entries, observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const counter = entry.target;
				const startValue = parseFloat(counter.getAttribute('data-count-start'));
				const endValue = parseFloat(counter.getAttribute('data-count-end'));
				const duration = parseFloat(counter.getAttribute('data-count-duration'));
				const isAnimated = counter.getAttribute('data-count-animated') === 'true';
				const metricElement = counter.querySelector('.metric');

				if (isAnimated) {
					countUp(counter, startValue, endValue, duration);
				} else {
					metricElement.textContent = endValue.toFixed(0);
				}

				observer.unobserve(counter);
			}
		});
	}

	const observer = new IntersectionObserver(onIntersection, {
		rootMargin: '0px',
		threshold: 0,
	});

	counters.forEach((counter) => observer.observe(counter));
}

document.addEventListener('DOMContentLoaded', initCountUp);
